import React from 'react';
import { useSelector } from 'react-redux';
import { getRbiRefundedOrderInfoWidgetData } from '../../../../../selectors/tools';
import {
  ResultsColumn,
  ResultsColumnHeader,
  Row,
  HeaderRow,
  RefundAmountsList,
  OrderedItemsList,
  Spreadsheet,
} from '../../DTInfoWidget.styles';

const DTRbiRefundedOrderInfoWidget = () => {
  const { customerName, refundedAmount, refundedItemsNamesList, transactionDateTime, storeAddress } = useSelector(
    getRbiRefundedOrderInfoWidgetData
  );

  return (
    <>
      <Spreadsheet className="fs-block">
        <HeaderRow>
          <ResultsColumnHeader>CUSTOMER NAME</ResultsColumnHeader>
          <ResultsColumnHeader>TRANSACTION DATE</ResultsColumnHeader>
          <ResultsColumnHeader>REFUNDED AMOUNT</ResultsColumnHeader>
          {Array.isArray(refundedItemsNamesList) && !!refundedItemsNamesList.length && (
            <ResultsColumnHeader>REFUNDED ITEMS</ResultsColumnHeader>
          )}
        </HeaderRow>
        <Row>
          <ResultsColumn>{customerName}</ResultsColumn>
          <ResultsColumn>{transactionDateTime}</ResultsColumn>
          <RefundAmountsList>{refundedAmount}</RefundAmountsList>
          {Array.isArray(refundedItemsNamesList) && !!refundedItemsNamesList.length && (
            <OrderedItemsList>
              {refundedItemsNamesList.map((name, idx) => (
                <li key={idx}>{name}</li>
              ))}
            </OrderedItemsList>
          )}
        </Row>
      </Spreadsheet>
      <Spreadsheet className="fs-block">
        <HeaderRow>
          <ResultsColumnHeader>STORE ADDRESS</ResultsColumnHeader>
        </HeaderRow>
        <Row>
          <ResultsColumn>{storeAddress}</ResultsColumn>
        </Row>
      </Spreadsheet>
    </>
  );
};
export default DTRbiRefundedOrderInfoWidget;
